import { api, ApiRequestConfig } from './api';
import type { DyPricesRequest, DyPrices } from '../types/dy-prices';

export const getDyPricesByIds = (props: DyPricesRequest, config: ApiRequestConfig) =>
  api.get<DyPrices>('get-products-price-by-id', { ...props }, config);
